export default __webpack_public_path__ + "static/media/sp.f57e1c6f.jpg";